// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { AuthorizationGrantRequired, CollectionEnvelope, Exception, ValidationFailure } from "../../lib"
import { GrantedPermissions } from "../../models"
import { BaseClient } from "../BaseClient"
import { Account } from "./Account"
import { AccountDTO } from "./AccountDTO"
import { IAccount } from "./IAccount"
import { IAccountClient } from "./IAccountClient"



export class AccountClient extends BaseClient implements IAccountClient {

  getBasePath(): string {
    return "/api/oauth/v2/resources/accounts"
  }

  create(params: any): IAccount {
    return new Account(this, params)
  }

  restore(dto: AccountDTO): IAccount {
    return new Account(this, dto)
  }

  async getAllPermissions(accountId: number): Promise<GrantedPermissions> {
    const response = await this.http.get(`/accounts/${accountId}/permissions`)
    let permissions: string[] = []
    if (!!response && response.status === 200) {
      permissions = response.data.permissions
    }
    return GrantedPermissions.from(permissions) as GrantedPermissions
  }

  async list(): Promise<CollectionEnvelope<AccountDTO>> {
    throw 'NotImplementedError'
  }

  async listAccountsForCurrentUser(): Promise<IAccount[]> {
    const self = this
    const response = await this.http.get('/accounts')
    if (!response || response.status === 401) {
      throw new AuthorizationGrantRequired(window.location.href)
    }
    return response.data.items.map((item: AccountDTO) => self.restore(item))
  }

  async persist(dto: AccountDTO, create?: boolean): Promise<void> {
    const response = await this.http.post('/accounts', dto)
    // TODO
    if (response.status === 422 && (response.data.errors || response.data.detail)) {
      throw new ValidationFailure(response.data.errors || response.data)
    }
  }
}